import { t } from '@lingui/core/macro';
import { Box, Typography } from '@pocketlaw/tetris';
function getJSON(content) {
    try {
        const parsed = JSON.parse(content);
        return parsed;
    }
    catch (_a) {
        return [];
    }
}
export function TabularContent(props) {
    const { content } = props;
    const columns = getJSON(content);
    const descriptionFallback = t({
        message: 'No prompt for this column',
        comment: 'Fallback text when no prompt for the column is available',
    });
    return (<Box flexDirection="column" gap="sm">
      {columns.map((column) => (<Box key={column.id} flexDirection="column">
          <Typography $fontSize="small" $fontWeight="bold">
            {column.name}
          </Typography>
          <Typography $fontSize="small" $fontWeight="regular">
            {column.description || descriptionFallback}
          </Typography>
        </Box>))}
    </Box>);
}
